export { default } from './Tabs';



// WEBPACK FOOTER //
// ./src/pages/partners/components/Tabs/index.js